import { Flex } from '@primitives/Layout'
import { fontSizes, Heading } from '@utils/Typography'
import { Text } from 'mds-web-ui'
import React from 'react'
import { InlineLink } from '../shared/InlineLink'
import { openBeaconMessage } from './beaconSupport'

export const ContactSupport = ({ slug, title }) => {
  return (
    <Flex
      as="section"
      aria-label="Contact support"
      flexDirection="column"
      gap={2}
      mt={4}
      width="100%"
    >
      <Heading as="h2" fontSize={fontSizes.body} m={0}>
        Still stuck?
      </Heading>
      <Text fontSize={1} color="#585859" m={0}>
        <InlineLink
          to={slug}
          onClick={event => {
            event.preventDefault()
            openBeaconMessage({
              slug,
              title,
              subject: `Help with: ${title}`
            })
          }}
        >
          Contact us
        </InlineLink>{' '}
        and we&apos;ll include this article in your message.
      </Text>
    </Flex>
  )
}
